export interface ISocialNetwork {
  label: string;
  to: string;
  icon: string;
  testId: string;
}

export const socialUrls = {
  discord: 'https://discord.gg/UpWnrtUaAu',
  facebook: 'https://www.facebook.com/maxquestofficial/',
  telegram: 'https://t.me/PlayMaxQuest',
  x: 'https://x.com/Maxduelpvp',
  twitch: 'https://www.twitch.tv/playmaxquest',
  tiktok: 'https://www.tiktok.com/@maxduelpvp',
  instagram: 'https://www.instagram.com/maxduelpvp/',
  youtube: 'https://www.youtube.com/@MaxDuelpvp',
};

export const MD_SUPPORT_EMAIL = 'support@maxduel.com';

export default [
  { label: 'Discord', to: socialUrls.discord, icon: 'SocialDiscord', testId: 'discord-link' },
  { label: 'TikTok', to: socialUrls.tiktok, icon: 'SocialTiktok', testId: 'tiktok-link' },
  { label: 'Instagram', to: socialUrls.instagram, icon: 'SocialInstagram', testId: 'instagram-link' },
  { label: 'X.com', to: socialUrls.x, icon: 'SocialX', testId: 'x-link' },
  { label: 'YouTube', to: socialUrls.youtube, icon: 'SocialYoutube', testId: 'youtube-link' },
] as ISocialNetwork[];
